module.exports = __webpack_public_path__ + "media/images/athletes/1681-33a72c200b7ace101bd3cad960acef34.png";